import React from 'react';
import { motion } from 'framer-motion';
import { useCvData } from '../context/CvDataContext.js';
import MediaGallery from './MediaGallery.js';
import './Education.css';

const Education = () => {
  const { education, loading, error, reload } = useCvData();
  if (error) return (
    <section className="education-section" id="education">
      <h2>Education</h2>
      <p role="alert">{error.message || 'Failed to load.'}</p>
      <button onClick={reload} className="retry-btn">Retry</button>
    </section>
  );
  if (loading) return (
    <section className="education-section" id="education">
      <h2>Education</h2>
      {[...Array(2)].map((_, idx) => (
        <div key={idx} className="education-item">
          <div className="skeleton skeleton-text lg" style={{ width: '40%' }} />
          <div className="skeleton skeleton-text" style={{ width: '30%' }} />
          <div className="skeleton skeleton-text" style={{ width: '20%' }} />
          <div className="skeleton skeleton-rect" style={{ marginTop: 12 }} />
        </div>
      ))}
    </section>
  );
  if (education.length === 0) return null;
  return (
    <section className="education-section" id="education">
      <h2>Education</h2>
      {education.map((edu, index) => (
        <motion.div
          key={edu.id}
          className="education-item"
          initial={{ opacity: 0, y: 50, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          transition={{
            duration: 0.6,
            delay: index * 0.1,
            type: "spring",
            stiffness: 100,
            damping: 15
          }}
          whileHover={{
            scale: 1.02,
            transition: { duration: 0.2 }
          }}
          whileTap={{ scale: 0.98 }}
        >
          <h3>{edu.degree}</h3>
          <span className="institution">{edu.institution}</span>
          <span className="period">{edu.period}</span>
          {edu.description && (
            <p className="education-description">{edu.description}</p>
          )}
          {(edu.media.images.length > 0 || edu.media.videos.length > 0) && (
            <div className="education-media">
              <MediaGallery media={edu.media} />
            </div>
          )}
        </motion.div>
      ))}
    </section>
  );
};

export default Education;
